// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"124":"d795488df0a34cac","475":"27a7bcedc7f8dfe9","2030":"8c25468a339f24b6","8445":"340d3bbb0efa344f"}[chunkId] + ".css";
};